<template>
  <div class="container">
    <el-card shadow="never">
    <h2>结算信息
    </h2>
    <el-divider/>
    <el-form-item label="结算对象" prop="settleTo" v-show="headShopMerchantIdInput">
      <el-select
        style="width:120px;"
        class="settleTo"
        placeholder="结算对象"
        clearable
        filterable
        v-model="settleForm.settleTo"
        :disabled="form.shopType === 2"
        @change="settleToMethod">
        <el-option label="结算给总店" :value="1" ></el-option>
        <el-option label="结算给分店" :value="0" ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="结算对象" prop="settleTo" v-show="!headShopMerchantIdInput">
      <el-select style="width:200px;" v-model="settleForm.settleTo">
        <el-option label="独立结算" :value="0"></el-option>
        <el-option label="与下属分店合并结算" :value="1" v-if="!isChain"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="结算类型" required>
      <el-row type="flex">
        <el-form-item class="form-flex-item" prop="accountType">
          <el-select
            style="width: 120px;"
            placeholder="账户类型"
            filterable
            v-model="settleForm.accountType"
            @change="setAccType"
            :disabled="settleToHead || form.merchantType === 1">
            <el-option label="对私账户" :value="1"></el-option>
            <el-option label="对公账户" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="legalFlag">
          <el-select
            style="width:120px;"
            placeholder="结算类型"
            filterable
            v-model="settleForm.legalFlag"
            :disabled="form.merchantType === 1">
            <el-option label="法人结算" :value="1"></el-option>
            <el-option label="非法人结算" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <a href="static/非法人结算授权书.pdf" download v-if="!readOnly">
          <div class="file-download-button">非法人结算授权书下载</div>
        </a>
      </el-row>
    </el-form-item>
    <div v-if="settleForm.legalFlag === 0">
      <el-form-item label="非法人授权书" prop="nonLegSettleAuthPic" required>
        <upload-img-ele
          v-model="settleForm.nonLegSettleAuthPic"
          :disabled="readOnly"
          valueName="settleForm.nonLegSettleAuthPic"
          :value="settleForm.nonLegSettleAuthPic"
          @upload="uploadSuccess"></upload-img-ele>
      </el-form-item>
      <el-form-item label="非法人证件照" required>
        <el-row type="flex">
          <el-form-item prop="nonLegIdcardFrontPic">
            <ocr-recognition
              type="8"
              :disabled="readOnly"
              label="身份证人像面"
              valueName="settleForm.nonLegIdcardFrontPic"
              :value="settleForm.nonLegIdcardFrontPic"
              @submit="getOCRResult"
              :to-check="needOcr"></ocr-recognition>
          </el-form-item>
          <el-form-item prop="nonLegIdcardBackPic" style="margin-left: 20px">
            <ocr-recognition
              type="7"
              :disabled="readOnly"
              label="身份证国徽面"
              valueName="settleForm.nonLegIdcardBackPic"
              :value="settleForm.nonLegIdcardBackPic"
              @submit="getOCRResult"
              :to-check="false"></ocr-recognition>
          </el-form-item>
        </el-row>
      </el-form-item>
    </div>
    <el-form-item :label="accountTypeLabel" prop="bankCardFrontPic" label-width="121px">
      <ocr-recognition
        type="9"
        :disabled="readOnly || settleToHead"
        :value="settleForm.bankCardFrontPic"
        v-if="settleForm.accountType === 1"
        valueName="settleForm.bankCardFrontPic"
        @submit="getOCRResult"
        :to-check="needOcr"></ocr-recognition>
      <upload-img-ele
        :disabled="readOnly || settleToHead"
        :value="settleForm.bankCardFrontPic"
        v-else
        valueName="settleForm.bankCardFrontPic"
        @upload="uploadSuccess"></upload-img-ele>
      <p v-if="settleForm.accountType === 2" class="form-tip-label">注：若无开户许可证，可用身份证，营业执照，结算确认书或其他图片进行代替</p>
    </el-form-item>
    <el-form-item label="开户名" prop="holder">
      <el-input class="form-input holder" v-model="settleForm.holder" :disabled="settleToHead" :placeholder="form.merchantType === 3 || form.merchantType === 2 && settleForm.accountType === 2? '与营业执照名称一致': '请填写结算人姓名'"></el-input>
    </el-form-item>
    <el-form-item id="bankCardNo" label="开户号" prop="bankCardNo">
      <el-input class="form-input" v-model="settleForm.bankCardNo" :disabled="settleToHead" :placeholder="settleForm.accountType === 2 ? '请填写开户许可证号' : '请填写结算人银行卡号或上传银行卡照片自动识别'" @blur="handleBankCardIdBlur"></el-input>
    </el-form-item>
    <el-form-item label="开户人证件号" prop="accountIdCardNo" v-show="settleForm.accountType !== 2">
      <el-input class="form-input accountIdCardNo" v-model="settleForm.accountIdCardNo" placeholder="上传身份证照自动识别或手动输入15/18位身份证号" :disabled="settleToHead">
        <el-select style="width:130px;" slot="prepend" placeholder="请选择证件类型" v-model="settleForm.bankIdCardType" disabled>
          <el-option label="身份证" :value="1"></el-option>
          <el-option label="港澳台通行证" :value="2"></el-option>
          <el-option label="台湾身份证" :value="3"></el-option>
          <el-option label="香港身份证" :value="4"></el-option>
          <el-option label="澳门身份证" :value="5"></el-option>
          <el-option label="护照" :value="6"></el-option>
          <el-option label="居住证" :value="7"></el-option>
          <el-option label="其他法定证件" :value="9"></el-option>
        </el-select>
      </el-input>
    </el-form-item>
    <bank-branch
      label-width="120px"
      ref="bankBranchForm"
      :value="bankBranch"
      v-model="bankBranch"
      :bankCardId="lumhBankCardId"
      :readOnly="readOnly || settleToHead"
      @getValue="getBankBranch"
      @error="getBranchError"></bank-branch>
    <el-form-item label="预留号码" prop="accountMobile">
      <el-input class="form-input" v-model="settleForm.accountMobile" clearable :disabled="settleToHead" placeholder="开户号银行预留号码"></el-input>
    </el-form-item>
    </el-card>
  </div>
</template>

<script>
import ocrRecognition from '@/components/OCRRecognition'
import uploadImgEle from '@/components/upload/uploadImgEle'
import bankBranch from '@/components/bankBranch'
import { agentMixins } from './agentMixins'
export default {
  mixins: [agentMixins],
  components: {
    ocrRecognition,
    uploadImgEle,
    bankBranch
  },
  data () {
    return {
      selectLoading: true,
      agentChannelList: [], // 渠道商列表
      // 商户入网信息
      lumhBankCardId: '', // 通过校验的银行卡号
      bankTypeError: false // 银行名称是否正确、
    }
  },
  mounted () {
  },
  computed: {
    bankBranch () {
      return {
        bankNameCode: this.settleForm.FBankTypeCode, // 银行类型编码
        bankCityCode: this.settleForm.FBankCityCode, // 银行网点市编码
        bankAreaCode: this.settleForm.FBankAreaCode, // 银行网点省编码
        bankBranchCode: this.settleForm.unionpay// 分行id
      }
    },
    headShopMerchantIdInput () {
      return this.form.shopType !== 1
    },
    accountTypeLabel () {
      if (this.settleForm.accountType === 2) {
        return '开户许可证照片'
      } else {
        return '银行卡照片'
      }
    },
    settleToHead () { return this.settleForm.settleTo === 1 && this.form.shopType !== 1 }
  },
  methods: {
    /**
             * @description 银行分行联动银行错误回调
             * @param {Object} value 组件传的参数，银行名称是否错误
             */
    getBranchError (value) {
      this.bankTypeError = value
    },
    /**
             * @description 开户号输入框获取焦点事件
             */
    handleBankCardIdBlur () {
      if (this.settleForm.bankCardNo && /^\d{16,19}$/.test(this.settleForm.bankCardNo)) {
        this.lumhBankCardId = this.settleForm.bankCardNo
      }
    },
    /**
     * @description 设置账户类型
     * @param {Number} value 1对私账户，2对公账户
     */
    setAccType (value) {
      this.$parent.$parent.$refs.settleForm.clearValidate('legalFlag')
      this.settleForm.accountType = value
      // 对公账户只能是法人结算，使用法人的信息
      this.settleForm.legalFlag = 1// 法人结算
      if (value === 2) {
        this.settleForm.holder = this.businessForm.licenseFullName
        this.settleForm.bankIdCardType = this.businessForm.credentialType
        this.settleForm.accountIdCardNo = this.businessForm.idCardNo
      } else {
        this.settleForm.holder = this.businessForm.legalName
        this.settleForm.bankIdCardType = this.businessForm.credentialType
        this.settleForm.accountIdCardNo = this.businessForm.idCardNo
      }
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
  .red label{
    color: red;
  }
  .form-input {
    width: 450px;
  }
  .form-flex-item {
    margin-right: 5px;
  }
  .form-tip-label {
    margin: 0;
    color:#D49B5F;
    vertical-align:middle;
    display:inline-block;
    font-size:14px;
    font-family:Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  }
  .file-download-button {
    color: #409eff;
    margin: 0 10px;
  }
  .report-config-id-tip-view {
    margin: 10px 100px;
    color: #606266;
    font-size: 14px;
  }
  @mixin flex-horizontal {
    display: -webkit-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .is-participate-view {
    @include flex-horizontal;
      margin-bottom: 10px;
    .is-participate-view-title {
      margin-right: 30px;
    }
  }
  .report-config-id-tip-view {
    margin: 10px 100px;
    color: #606266;
    font-size: 14px;
  }
  .merchant-info-head-view {
    @include flex-horizontal;
    justify-content: space-between;
    .merchant-info-title-view {
      flex: 1;
    }
    .merchant-info-batch-import-view {
      .merchant-info-batch-import-buttons {
        @include flex-horizontal;
      }
      .new-file-tip {
        font-size: 14px;
        margin: 5px 0;
      }
      .new-file-name {
        font-size: 14px;
      }
    }
  }
  .submitBtn{
    display: block;
    margin: 20px auto;
  }
  .reviewTime{
    line-height: 30px;
    height: 30px;
    display: inline-block;
    font-size: 14px;
    color: #727272;
  }
  p.form-tip-label{
    display: block;
  }
</style>
